import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../services/master/MasterService';

const TipeTemp = ({id}) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [tipeTemp, setTipeTemp] = useState('')

    useEffect(() => {
        const getTipeTemp = async () => {
            const response = await masterService.getTemperaturById(id)
            setTipeTemp(response.data.jnsTemperature)
        }
        getTipeTemp()
    }, [masterService, id])

    return (
        <>
            {tipeTemp}
        </>
    )
}

export default TipeTemp